import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-neutral-900 mb-3">
          {t('checkout.success')}
        </h1>

        <p className="text-neutral-600 mb-2">
          {t('checkout.subscriptionActive')}
        </p>
        <p className="text-neutral-500 text-sm mb-8">
          {t('checkout.allFeatures')}
        </p>

        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-primary-600 text-white font-semibold rounded-xl hover:bg-primary-700 transition-colors shadow-lg"
        >
          {t('checkout.goToDashboard')}
        </button>

        <p className="text-xs text-neutral-400 mt-4">
          {t('checkout.redirecting')}
        </p>
      </div>
    </div>
  );
}
